import { render, staticRenderFns } from "./leftCover_rightTitle.vue?vue&type=template&id=2e0f5f4e&scoped=true&"
import script from "./leftCover_rightTitle.vue?vue&type=script&lang=js&"
export * from "./leftCover_rightTitle.vue?vue&type=script&lang=js&"
import style0 from "./leftCover_rightTitle.vue?vue&type=style&index=0&id=2e0f5f4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0f5f4e",
  null
  
)

export default component.exports